import { __rest } from 'tslib';
import React from 'react';
import { styled, Col, Button, Row, Currency } from '@teko/ui';

var background = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22352%22%20height%3D%2240%22%20viewBox%3D%220%200%20352%2040%22%3E%20%20%20%20%3Cpath%20fill%3D%22%23FFF%22%20fill-rule%3D%22evenodd%22%20stroke%3D%22%23E0E0E0%22%20d%3D%22M351.5.5H.5v3.027c1.043.116%201.978.587%202.682%201.291C3.996%205.632%204.5%206.758%204.5%208c0%201.243-.504%202.368-1.318%203.182-.704.704-1.64%201.175-2.682%201.29v3.055c1.043.116%201.978.587%202.682%201.291.814.814%201.318%201.94%201.318%203.182%200%201.243-.504%202.368-1.318%203.182-.704.704-1.64%201.175-2.682%201.29v3.055c1.043.116%201.978.587%202.682%201.291.814.814%201.318%201.94%201.318%203.182%200%201.243-.504%202.368-1.318%203.182-.704.704-1.64%201.175-2.682%201.29V39.5h351v-3.027c-1.043-.116-1.978-.587-2.682-1.291-.814-.814-1.318-1.94-1.318-3.182%200-1.243.504-2.368%201.318-3.182.704-.704%201.64-1.175%202.682-1.29v-3.055c-1.043-.116-1.978-.587-2.682-1.291-.814-.814-1.318-1.94-1.318-3.182%200-1.243.504-2.368%201.318-3.182.704-.704%201.64-1.175%202.682-1.29v-3.055c-1.043-.116-1.978-.587-2.682-1.291-.814-.814-1.318-1.94-1.318-3.182%200-1.243.504-2.368%201.318-3.182.704-.704%201.64-1.175%202.682-1.29V.5z%22%2F%3E%3C%2Fsvg%3E";

const CouponWrapper = styled.div `
  display: flex;
  flex-direction: row;
  background-image: url('${background}');
  background-size: contain;
  background-repeat: no-repeat;
`;
const StyledCol = styled(Col) `
  margin-top: 10px;
  padding: 0px;
  text-align: right;
  color: #ef2741;
  font-weight: 500;
  span {
    margin-right: -6px;
  }
`;
const StyledButton = styled(Button) `
  padding-left: 0px;
`;
const CloseButton = styled(Button) `
  padding-right: 0px;
  padding-top: 8px;
  padding-left: 6px;
`;
const AppliedCoupon = (_a) => {
    var { text, discount, type, action, isCloseHidden = false } = _a, props = __rest(_a, ["text", "discount", "type", "action", "isCloseHidden"]);
    const onRemoveClicked = () => {
        if (action)
            action();
    };
    return (React.createElement(CouponWrapper, Object.assign({}, props),
        React.createElement(Col, { col: 6 },
            React.createElement(StyledButton, { link: true, disabled: true, icon: {
                    name: type == 'coupon' ? 'percentage' : 'tag',
                    size: 25,
                } }, text)),
        React.createElement(Col, { col: 6 },
            React.createElement(Row, null,
                React.createElement(StyledCol, { col: 8 },
                    "-",
                    React.createElement(Currency, { value: discount })),
                !isCloseHidden && (React.createElement(Col, { col: 4 },
                    React.createElement(CloseButton, { link: true, icon: { name: 'circle-close', size: 20, color: '#e0e0e0' }, onClick: onRemoveClicked, "data-track-content": true, "data-content-region-name": "couponSection", "data-content-name": "removeCoupon" })))))));
};

export { AppliedCoupon as A };
